<template>
  <m-modal
    :show="show"
    @close="dismiss"
    sidebarHeaderText="Delete Item"
  >
    <div class="mt-4 flex">
      <!-- eslint-disable-next-line max-len -->
      <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
        <!-- Heroicon name: outline/exclamation -->
        <!-- eslint-disable-next-line max-len -->
        <svg class="h-6 w-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <!-- eslint-disable-next-line max-len -->
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <slot>
        <div class="mt-4 text-center sm:mt-2 sm:ml-4 sm:text-left">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            Delete Item
          </h3>
          <div class="mt-2 text-sm text-gray-600">
            <p class="font-medium text-gray-700">
              Are you sure you want to delete this item?
            </p>
            <!-- eslint-disable-next-line max-len -->
            <p class="max-w-2xl">Deleting this item will remove it permanently from the Super Toolkit. This action cannot be undone.</p>
          </div>
        </div>
      </slot>
    </div>
    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <div class="ml-3 relative">
        <m-button
          class="bg-red-600 hover:bg-red-700"
          @click="handleDelete"
          data-test="delete-btn"
        >
          Delete
        </m-button>
        <div
          class="absolute inset-0 flex items-center justify-center bg-red-700 rounded"
          v-if="isLoading"
        >
          <div class="h-4 w-4">
            <m-loader class="text-white"></m-loader>
          </div>
        </div>
      </div>
      <m-button variant="secondary" @click="dismiss">
        Cancel
      </m-button>
    </div>
  </m-modal>
</template>

<script>
import { API, ENDPOINTS } from '@/app/services/api-url';

export default {
  name: 'confirm-delete-modal',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    deleteItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    handleDelete() {
      this.isLoading = true;
      API.delete(`${ENDPOINTS.DELETE_TOOLKIT_ITEM}/${this.deleteItem.id}?type=${this.deleteItem.type}`)
        .then((res) => {
          if (res.status === 204) {
            this.isLoading = false;
            this.$emit('close');
          }
        })
        .catch(err => console.log(err));
    },
    dismiss() {
      this.$emit('close');
    },
  },
};
</script>
